<template>
  <div>
    <div class="d-flex justify-content-start align-items-center mb-2">
      <div class="mr-3">
        <Link href="/api">
          &lt; Назад
        </Link>
      </div>
      <div>
        <api-doc-badge
          v-for="method in item.methods"
          :key="method"
          :method="method"
        />
        <i
          v-if="item.auth"
          class="el-icon-lock text-danger mr-2"
        />
        {{ item.name }}
      </div>
    </div>

    <div
      v-if="description"
      class="mb-3 h4"
    >
      {{ description }}
    </div>

    <div class="text-muted">
      <div class="mb-2">
        <strong class="text-black">URL:</strong>
        <a
          :href="demoUrl"
          target="_blank"
        >{{ item.url }}</a>
      </div>
      <div class="mb-2">
        <strong class="text-black">Имя:</strong> {{ item.name }}
      </div>

      <div class="text-black mt-4">
        <b>Параметры:</b>
      </div>
      <div
        v-for="(params, key) in paramsIn"
        :key="key"
        class="mb-2"
      >
        <span class="">
          <span class="text-black">{{ key }}: </span>
        </span>
        <span v-if="!Array.isArray(params)">{{ params }}</span>
        <span v-else>
          <api-doc-param-info
            v-for="(param, index) in params"
            :key="index"
            class="mr-3"
            :param="param"
          />
        </span>
      </div>

      <div v-if="fieldsOut">
        <div class="text-black mt-4">
          <b>Поля:</b>
        </div>
        <div
          v-for="(value, key) in fieldsOut"
          :key="key"
          class="mb-2"
        >
          <span class="">
            <span class="text-black">{{ key }}: </span>
          </span>
          {{ value }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3';

import ApiDocLayout from '@/Layouts/ApiDocLayout';
import ApiDocBadge from '@/Pages/ApiDoc/ApiDocBadge';
import ApiDocParamInfo from '@/Pages/ApiDoc/ApiDocParamInfo';

export default {
  name: 'ApiDocMethod',
  components: {
    ApiDocParamInfo, ApiDocBadge, Link,
  },
  layout: ApiDocLayout,

  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      form: {},
      showForm: false,
      execute: '',
    };
  },
  computed: {
    description() {
      return this.item?.doc?.description ?? '';
    },
    paramsIn() {
      return this.item?.doc?.in ?? false;
    },
    fieldsOut() {
      return this.item?.doc?.fields ?? false;
    },
    demoUrl() {
      return this.item?.doc?.demo_url ?? this.item.url;
    },
  },
  mounted() {
    this.execute = this.item.url;
  },
};
</script>
<style>
.text-black {
    color: black;
}
</style>
